'use client';
import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import cn from './style.module.scss';
type CommonWrapperProps = {
  children: React.ReactNode;
  transition?: string;
};

const CommonWrapper = ({
  children,
  transition = 'opacity 0.3s ease-in-out',
}: CommonWrapperProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [showContent, setShowContent] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setShowContent(true);
    gsap.fromTo(
      contentRef.current,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 1,
        ease: 'power2.out',
      }
    );
  }, []);

  return (
    <div
      className={cn.commonWrapper}
      ref={contentRef}
      style={{
        opacity: showContent ? 1 : 0,
        transition,
      }}
    >
      {children}
    </div>
  );
};

export default CommonWrapper;
